import { useJsApiLoader } from '@react-google-maps/api'
import { createContext, useContext } from 'react'

const LIBRARIES: ('places' | 'marker')[] = ['places', 'marker']

interface GoogleMapsContextValue {
    isLoaded: boolean
}

const GoogleMapsContext = createContext<GoogleMapsContextValue>({ isLoaded: false })

export function useGoogleMaps() {
    return useContext(GoogleMapsContext)
}

export function GoogleMapsProvider({ children }: { children: React.ReactNode }) {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
        libraries: LIBRARIES,
    })

    return (
        <GoogleMapsContext.Provider value={{ isLoaded }}>
            {children}
        </GoogleMapsContext.Provider>
    )
}
